import { Routes } from "@angular/router";

// Utils
import { constants } from "src/app/utils/constants";

//Guards
import { RoleGuard } from "../../services/guards/role.guard";

//Components
import { LastRequestsComponent } from "../requests/last-requests/last-requests.component";
import { UserManagementComponent } from "../admin/user-management/user-management.component";
import { ExecutiveComponent } from "./executive/executive.component";

export const HOME_ROUTES: Routes = [
  {
    path: "last-requests",
    component: LastRequestsComponent,
    canActivate: [RoleGuard],
    data: {
      expectedRoles: [
        constants.rules.codes.roles.admin.value,
        constants.rules.codes.roles.responsibleForRequests.value,
        constants.rules.codes.roles.treasurer.value,
        constants.rules.codes.roles.supervisor.value,
      ],
    }
  },
  {
    path: "user-management",
    component: UserManagementComponent,
    canActivate: [RoleGuard],
    data: {
      admin: true,
      title: "Gestión de usuario",
      expectedRoles: [constants.rules.codes.roles.admin.value],
    },
  },
  {
    path: "executive",
    component: ExecutiveComponent,
    canActivate: [RoleGuard],
    data: {
      expectedRoles: [constants.rules.codes.roles.admin.value],
      onlyExecutive: true,
    }
  },
];
